<template>
  <div>
    <button
      v-for="option in options"
      :key="option.key"
      class="button px-2"
      :class="[{ active: option.key === selectedKey, disabled: !option.available }, buttonClasses]"
      :style="width ? 'width: ' + width : ''"
      @keyup.space="selectHandler(option)"
      @click="selectHandler(option)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue';
import { IToggleGroupOption } from '../interfaces';

export default defineComponent({
  props: {
    options: {
      type: Array<IToggleGroupOption>,
      default: []
    },
    selectedKey: {
      type: String as PropType<string | null>,
      default: null,
    },
    select: {
      type: Function,
      default: (key: string) => console.log('select not implemented'), // eslint-disable-line no-console
    },
    width: {
      type: String,
      default: null,
    },
    buttonClasses: {
      type: String,
      default: null,
    }
  },

  methods: {
    selectHandler(option: IToggleGroupOption) {
      if (option.available) {
        this.select(option.key)
      }
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';
@import '@gecko-akh/shared-styles/src/styles/vars.scss';

.button {
  background-color: $color-aida-white;
  border-top: 2px solid $color-expinet-dark-gray;
  border-bottom: 2px solid $color-expinet-dark-gray;
  border-left: 1px solid $color-expinet-dark-gray;
  border-right: 1px solid $color-expinet-dark-gray;
  cursor: default;
  flex: 1;

  &:first-child {
    border-top-left-radius: $radius-rounded;
    border-bottom-left-radius: $radius-rounded;
    border-left: 2px solid $color-expinet-dark-gray;
  }

  &:last-child {
    border-top-right-radius: $radius-rounded;
    border-bottom-right-radius: $radius-rounded;
    border-right: 2px solid $color-expinet-dark-gray;
  }

  &.active {
    border-color: $color-expinet-blue;
    color: $color-aida-white;
    background-color: $color-expinet-blue;
    font-weight: bold;
}

  &:not(.disabled, .active) {
    &:hover, &:focus {
      border-color: $color-expinet-blue-h;
      background-color: $color-expinet-blue-h;
      color: $color-aida-white;
      cursor: pointer;
    }
  }

  &.disabled {
    color: $color-expinet-gray;
    cursor: default;
    border-top: 2px solid $color-expinet-gray;
    border-bottom: 2px solid $color-expinet-gray;
    border-left: 1px solid $color-expinet-gray;
    border-right: 1px solid $color-expinet-gray;
  }
}
</style>
